export default __webpack_public_path__ + "static/media/INTERACT.ed702411.png";